import React from "react"

import AutomationContainer from "features/Automation/containers/Automation.container"

const Automation: React.FC = () => {
  return (
    <>
      <title>DATA(Q) - Automation Scripts</title>
      <AutomationContainer />
    </>
  )
}

export default Automation
